<template>
    <div class="lite_select_view" v-if="(data && data.did) || (arrData && arrData.length>0)">
        <!-- 单选 -->
        <div class="lite_select_view_box" v-if="(data && data.did)">
            <div :class="'drive-icon drive-icon-' + getDrive(data.did).type"></div>
            <div class="lite_select_view_path">{{ getDrive(data.did).name + getNodePath(data.node) }}</div>
        </div>
        <!-- 多选，单个 -->
        <div class="lite_select_view_box" v-if="(arrData && arrData.length==1)">
            <div :class="'drive-icon drive-icon-' + getDrive(arrData[0].did).type"></div>
            <div class="lite_select_view_path">{{ getDrive(arrData[0].did).name + getNodePath(arrData[0].node) }}</div>
        </div>
        <!-- 多选，多个 -->
        <div class="lite_select_list myscroll" v-if="(arrData && arrData.length>1)">
            <div class="lite_select_list_item" v-for="(item,index) in arrData" :key="item.did+(item.node?item.node.id:'')">
                <!-- 文件图标 -->
                <img v-if="item.node" class="select-node-icon" :src="'/static/file/'+item.node.icon+'.svg'" @error="e => e.target.src = '/static/file/file.svg'" />
                <!-- 云盘图标 -->
                <div v-else :class="'drive-icon drive-icon-' + getDrive(item.did).type"></div>
                <!-- 路径 -->
                <div class="lite_select_view_path">{{ getDrive(item.did).name + getNodePath(item.node) }}</div>
                <!-- 移除 -->
                <div class="lite_select_view_close" @click.stop="removeItem(index)"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: { type: Object, default: null },
        arrData: { type: Array, default: null },
    },
    methods: {
        removeItem(index) {
            this.arrData.splice(index, 1);
        },
        // 获取云盘
        getDrive(id) {
            for (let i = 0; i < this.$store.state.drives.length; i++) {
                let drive = this.$store.state.drives[i];
                if (drive.id === id) {
                    return drive;
                }
            }
            return null;
        },
        // 获取节点路径
        getNodePath(node) {
            let path = '';
            let arr = this.getNodeArr(node);
            for (let i = 0; i < arr.length; i++) {
                let item = arr[i];
                path += '/' + item.name;
            }
            return path;
        },
        // 获取节点和父
        getNodeArr(node) {
            let arr = [];
            while (node) {
                arr.push(node);
                node = node.parent;
            }
            return arr.reverse();
        },
    },
};
</script>

<style scoped>
/* 布局 */
.lite_select_view {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    background-color: #FFF;
}

/* 选择的云盘数据展示 */
.lite_select_view_box {
    width: 100%;
    height: 160px;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    z-index: 2;
    margin: auto;
    top: 0;
    bottom: 0;
}

/* 云盘图标 */
.drive-icon {
    width: 75px;
    height: 75px;
    display: inline-block;
    margin-bottom: 50px;
    background-repeat: no-repeat;
    background-size: cover;
}

/* 云盘路径 */
.lite_select_view_path {
    font-size: 16px;
    color: rgba(88, 88, 88, 0.6);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 多选 */
.lite_select_list {
    height: 100%;
    overflow: auto;
}

/* 单个 */
.lite_select_list_item {
    border: 1px solid #f1f6fd;
    margin: 20px;
    padding: 10px;
    text-align: left;
}

/* 边框 */
.lite_select_list_item:hover {
    border: 1px solid #b3bcf6;
}

/* 图标 */
.lite_select_list_item>.select-node-icon,
.lite_select_list_item>.drive-icon {
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 0px;
    margin-right: 5px;
}

/* 路径 */
.lite_select_list_item>.lite_select_view_path {
    max-width: calc(100% - 60px);
    height: 24px;
    line-height: 24px;
    display: inline-block;
    vertical-align: middle;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

/* 移除 */
.lite_select_view_close {
    width: 24px;
    height: 24px;
    background-image: url("../../assets/images/lite/icon/close.svg");
    background-repeat: no-repeat;
    background-position: center;
    float: right;
    display: none;
}

.lite_select_view_close:hover {
    background-color: #f1f6fd;
}

.lite_select_list_item:hover>.lite_select_view_close {
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_select_view.vue